import React from 'react';
import { Modal, Button } from 'antd';
import './coding-challenge-warning.scss';
import { ClockIcon } from '../../../legacy_components/components/common/CustomIcon';
import { PlayCircleOutlineRounded } from '@material-ui/icons';
import { changePreviousDevData } from '../util';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import useFlagsFromBackend, {
  GB_FLAGS,
} from '../../../../dv2_temporary_solution/services/launchDarkly';
import LaptopIcon from '../../../assets/img/laptop-icon.svg';
import VideoCameraIcon from '../../../assets/img/video-camera.svg';
import ReportIcon from '../../../assets/img/report.svg';
import RecordScreenIcon from '../../../assets/img/record-screen.svg';
import CompassIcon from '../../../assets/img/compass.svg';
import { turingLogger } from '../../../../shared/TuringLogger';

const CodingChallengeWarning = ({ home, onStart, onCancel, isInProgress, user, codingChallengeId, isVetsmithACC = false}) => {
  const {
    show_acc_plagiarism_warning,
    use_acc_video_recording,
  } = useFlagsFromBackend([
    GB_FLAGS.show_acc_plagiarism_warning,
    GB_FLAGS.use_acc_video_recording,
  ]);
  let buttonText = 'Start Coding Challenge';
  if (isInProgress) {
    buttonText = 'Continue';
  } else if (show_acc_plagiarism_warning || use_acc_video_recording) {
    buttonText = 'Accept and start Challenge';
  }

  return use_acc_video_recording || show_acc_plagiarism_warning ? (
    <Modal
      visible={true}
      footer={null}
      width={
        use_acc_video_recording
          ? '721px'
          : show_acc_plagiarism_warning
          ? '680px'
          : '504px'
      }
      onCancel={onCancel}
    >
      <div
        className="codingChallengeWarning"
        style={use_acc_video_recording ? { padding: 0 } : {}}
      >
        <div
          className="title"
          style={use_acc_video_recording ? { marginBottom: 24 } : {}}
        >
          <div className="text">
            {use_acc_video_recording
              ? 'Coding Challenge Agreement'
              : 'Start Coding Challenge Now?'}
          </div>
        </div>

        {!use_acc_video_recording && (
          <p className="description">
            The time will start running after you proceed. You can only take this quiz once.
          </p>
        )}

        {use_acc_video_recording && (
          <React.Fragment>
            <div className="useAccVideoRecording">
              <h4 className="title">General information:</h4>
              {isVetsmithACC ? (
                <p>
                  The time will start running after you proceed. Keep
                  in mind you <b>can only take this test once</b>, so make sure you have a stable internet connection while attempting the challenge.
                </p>
              ):(
                <p>
                  You will have up to 30 minutes to complete this Coding
                  Challenge. The time will start running after you proceed. Keep
                  in mind you <b>can only take this test once</b>, so make sure you have a stable internet connection while attempting the challenge.
                </p>
              )}
            </div>

            <div>
              <h4 className="title">Fair assessment policy:</h4>

              <p>
                For your test attempt to be considered valid, you <b>accept</b> that during this session:
              </p>

              <div>
                <div className="useAccVideoRecording listItem">
                  <img
                    src={LaptopIcon}
                    className="listItemImg"
                    style={{ marginRight: 16 }}
                  />
                  <div className="text">Your entire screen will be recorded, not just a specific tab or window.</div>
                </div>

                <div className="useAccVideoRecording listItem">
                  <img
                    src={VideoCameraIcon}
                    className="listItemImg"
                    style={{ marginRight: 16 }}
                  />
                  <div className="text">
                    Your video and audio will be recorded. You will need a working
                    webcam/camera and microphone, in a well-lit environment with
                    clear view of your face and clear audio without background
                    noise. Absence of clear video and audio will result in an invalid test attempt.
                  </div>
                </div>

                <div className="useAccVideoRecording listItem">
                  <img
                    src={RecordScreenIcon}
                    className="listItemImg"
                    style={{ marginRight: 16 }}
                  />
                  <div className="text">
                    Recording is required and cannot be stopped at any point
                    during the Challenge. If the recording is paused more than once, it will result in automatic disqualification from the test.
                  </div>
                </div>

                <div className="useAccVideoRecording listItem">
                  <img
                    src={CompassIcon}
                    className="listItemImg"
                    style={{ marginRight: 16 }}
                  />
                  <div className="text">
                    These recordings are subject to Turing's review at any
                    point.
                  </div>
                </div>

                <div className="useAccVideoRecording listItem">
                  <img
                    src={ReportIcon}
                    className="listItemImg"
                    style={{ marginRight: 16 }}
                  />
                  <div className="text">
                    <b>Any form of cheating will lead to temporary or permanent account
                    deactivation.</b>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}

        {!use_acc_video_recording && show_acc_plagiarism_warning && (
          <PlagiarismWarning />
        )}

        {!use_acc_video_recording && (
          <div className="actionContainer">
            <Button
              type="primary"
              className="button"
              onClick={() => {
                if(!isVetsmithACC){
                  changePreviousDevData(
                    home.extraPassedInfo.passedAcc,
                    'passedAcc'
                  );
                }
                onStart();
              }}
            >
              <PlayCircleOutlineRounded /> {buttonText}
            </Button>
          </div>
        )}

        {use_acc_video_recording && (
          <div className="actionContainer useAccVideoRecording">
            <Button
              type="primary"
              className="button"
              onClick={() => {
                if(!isVetsmithACC){
                  changePreviousDevData(
                    home.extraPassedInfo.passedAcc,
                    'passedAcc'
                  );
                }
                turingLogger
                  .log({
                    eventName: 'ACC_PROCTORING_CONSENT',
                    logData: {
                      challengeId: codingChallengeId,
                      userId: user && user.uid,
                      consentStatus: 'ALLOW',
                      timestamp: new Date(),
                    },
                  })
                  .catch((e) =>
                    console.log('error logging ACC_PROCTORING_CONSENT', e)
                  );
                onStart();
              }}
            >
              Accept and Start Challenge
            </Button>
          </div>
        )}
      </div>
    </Modal>
  ) : null;
};

export const PlagiarismWarning = React.memo(() => {
  return (
    <div className="plagiarism-warning">
      <div className="warning-icon">
        <FontAwesomeIcon icon={faExclamationTriangle} fontSize="25px" />
      </div>
      <div>
        <b>Rules against cheating/plagiarism:</b>
        <ul>
          <li>
            I acknowledge and accept that this session will be recorded and
            analyzed.
          </li>
          <li>
            I acknowledge and accept that copy-pasting, plagiarism and any form
            of cheating is against the terms of service and will result in a
            permanent deactivation of my account.
          </li>
        </ul>
      </div>
    </div>
  );
});

const mapStateToProps = (state) => ({ home: state.home });

export default connect(mapStateToProps, null)(CodingChallengeWarning);
